module.exports = __webpack_public_path__ + "static/media/sketch.e7c82e5c.jpg";